import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section aria-labelledby="hero-heading" className="bg-brand-paper px-5 pb-16 pt-8 lg:px-8 lg:pb-20 lg:pt-12" data-id="element-96" data-mp="16njcg4ablb52">
      <div className="mx-auto max-w-4xl text-center" data-id="element-97" data-mp="12m7rwd6azg3q">
        <p className="mx-auto w-fit rounded-full bg-brand-plum px-4 py-1.5 font-body text-[10px] font-bold uppercase tracking-[0.16em] text-white sm:text-[11px]" data-id="element-98" data-mp="12nsoe8c6h948">
          For Makeup Instructors & Educators
        </p>

        <h1 id="hero-heading" className="mt-5 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-99" data-mp="1ubb209kvfkoa">
          Stop Spending Hours Preparing Every Class <Accent data-id="element-100" data-mp="exetma27kw5y">From Scratch.</Accent>
        </h1>
      </div>

      <img src={MOCKUP_URL} alt="Makeup Instructor Ready — the six core volumes with real inside pages on a tablet, laptop and phone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-6 block w-full max-w-[1060px] object-contain" style={{
      filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
    }} data-id="element-101" data-mp="9xk4oc1zugnj" />

      <p className="mx-auto mt-6 max-w-2xl text-center text-[16px] font-medium leading-relaxed text-brand-charcoal/80 sm:text-[17px]" data-id="element-102" data-mp="34ehkkttf4uak">
        Get your lessons, student exercises, technique guides and assessments already organized — so you can
        prepare faster and focus on teaching.
      </p>

      <p className="mx-auto mt-6 w-fit rounded-full border border-brand-plum/20 bg-white px-5 py-2 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-103" data-mp="2gpf1rin1sveh">
        6 Core Volumes + 5 Bonuses
      </p>

      <CtaBlock label="Get Instant Access" className="mt-6" data-id="element-104" data-mp="26s0nnpolkipc" />
    </section>;
}